import { errorCollection } from "@/firebase";

const state = {
  error: {}
};

const getters = {};

const actions = {
  /*getError({ commit }, payload) {
    errorCollection
      .where("client", "==", payload)
      .orderBy("name", "asc")
      .get()
      .then(querySnapshot => {
        let tempData = [];
        querySnapshot.forEach(doc => {
          tempData.push(Object.assign(doc.data(), { id: doc.id }));
        });
        commit("getDelivery", tempData);
      });
  },*/
  // eslint-disable-next-line
  addError({ commit }, payload) {
    console.log("ERROR DISPACHED", payload);
    errorCollection.add(payload).then(() => {
      console.log("ERROR ADDED");
    });
    /*errorCollection.add(payload).then(docRef => {
      commit("addError", Object.assign(payload, { id: docRef.id }));
    });*/
  },
  /*removeDelivery({ commit }, payload) {
    deliveryCollection
      .doc(payload)
      .delete()
      .then(() => {
        commit("removeDelivery", payload);
      });
  },
  editDelivery({ commit }, payload) {
    deliveryCollection
      .doc(payload.id)
      .set(payload)
      .then(() => {
        commit("editDelivery", payload);
      });
  }*/
};

const mutations = {
  /*getDelivery(state, payload) {
    state.delivery = payload;
    //console.log(state.delivery);
  },
  addError(state, payload) {
    state.error.push(payload);
  },*/
  /*removeDelivery(state, payload) {
    const index = state.delivery.findIndex(item => item.id == payload);
    state.delivery.splice(index, 1);
  },
  editDelivery(state, payload) {
    const index = state.delivery.findIndex(item => item.id == payload.id);
    state.delivery.splice(index, 1, payload);
  }*/
};

export default {
  state,
  getters,
  actions,
  mutations
};
